const PERMISSIONS = ['create', 'edit', 'view', 'delete'];
const VIEW_ONLY = 'view';

export const hasAnyMenuPermission = (permissions = []) =>
  permissions.some((item) => {
    if (item.submenu?.length) {
      return item.submenu.some((sub) => PERMISSIONS.some((permission) => sub[permission]));
    }
    return PERMISSIONS.some((permission) => item[permission]);
  });

export const buildPermissionStatusFromMenu = (sections) => {
  const tempData = [];
  sections.forEach((element) => {
    const newObj = { section: `${element.modules}` };
    if (element.subMenu) {
      newObj.submenu = [];
      element.subMenu.forEach((subItem) => {
        const subObj = { section: `${subItem.modules}` };
        PERMISSIONS.forEach((permission) => {
          subObj[permission] = false;
        });
        newObj.submenu.push(subObj);
      });
      newObj[VIEW_ONLY] = false;
    } else if (element.modules === 'dashboard') {
      newObj[VIEW_ONLY] = false;
    } else {
      PERMISSIONS.forEach((permission) => {
        newObj[permission] = false;
      });
    }
    tempData.push(newObj);
  });
  return tempData;
};

export const mergeStoredPermissions = (sections, storedPermissions = []) => {
  const base = buildPermissionStatusFromMenu(sections);
  const stored = Array.isArray(storedPermissions) ? storedPermissions : [];

  return base.map((item) => {
    const saved = stored.find((entry) => entry.section === item.section);
    if (!saved) return item;

    if (item.submenu && Array.isArray(saved.submenu)) {
      return {
        ...item,
        view: Boolean(saved.view),
        submenu: item.submenu.map((sub) => {
          const savedSub = saved.submenu.find((entry) => entry.section === sub.section);
          return savedSub ? { ...sub, ...savedSub } : sub;
        }),
      };
    }

    if (item.section === 'dashboard') {
      return { ...item, view: Boolean(saved.view) };
    }

    return {
      ...item,
      create: Boolean(saved.create),
      edit: Boolean(saved.edit),
      view: Boolean(saved.view),
      delete: Boolean(saved.delete),
    };
  });
};

export const grantSectionPermissions = (item, menuSection, checked) => {
  if (menuSection?.subMenu) {
    return {
      ...item,
      view: checked,
      submenu: (item.submenu || []).map((sub) => ({
        ...sub,
        create: checked,
        edit: checked,
        view: checked,
        delete: checked,
      })),
    };
  }
  if (item.section === 'dashboard') {
    return { ...item, view: checked };
  }
  return {
    ...item,
    create: checked,
    edit: checked,
    view: checked,
    delete: checked,
  };
};

export const isSectionGranted = (item, menuSection) => {
  if (menuSection?.subMenu) {
    return (
      !!item.view &&
      (item.submenu || []).every((sub) => sub.create && sub.edit && sub.view && sub.delete)
    );
  }
  if (item.section === 'dashboard') return !!item.view;
  return !!(item.create && item.edit && item.view && item.delete);
};
